import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Container,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { ZSpinner } from '@marageti/z4-lib';
// import { format } from 'date-fns';
import { SalesRecording } from '@marageti/z4-sdk/lib/travel';
import InvoiceTable from './invoice-table';

type Props = {
  isLoading: boolean;
  onChangeMonth: (value: Date | null) => void;
  sales: SalesRecording[] | undefined;
  selectedMonth: Date | null;
  totalSales: string | number | undefined;
  totalCommission: string | number | undefined;
};

const minDate = new Date('2008-01-01T00:00:00');

const InvoiceView = ({
  isLoading,
  onChangeMonth,
  sales,
  selectedMonth,
  totalSales,
  totalCommission,
}: Props) => (
  <Container maxWidth="xl">
    <Box
      sx={{
        pt: { desktop: 6.5, mobile: 6.5 },
        pb: 20,
        maxWidth: { desktop: 'xl' },
        margin: { desktop: '0 auto 56px' },
      }}
    >
      <Stack spacing={5}>
        <Stack spacing={2}>
          <DatePicker
            label="Invoice Month"
            onChange={onChangeMonth}
            value={selectedMonth}
            minDate={minDate}
            views={['month', 'year']}
            slotProps={{
              textField: {
                sx: {
                  maxWidth: { desktop: '304px' },
                  width: '100%',
                },
                className: 'custom-datePicker',
              },
            }}
          />
        </Stack>
        {(!isLoading && sales?.length === 0) ? (
          <Card>
            <CardContent>
              <Typography variant="body" color="primary.light" textAlign="center">
                There are no sales recordings for the selected month.
              </Typography>
            </CardContent>
          </Card>
        ) : (
          <>
            <Stack direction={{ desktop: 'row' }} spacing={2.5}>
              <Card sx={{ flex: 1, mb: { mobile: 3, desktop: 'none' } }}>
                {isLoading ? (
                  <Skeleton variant="rounded" height={116} />
                ) : (
                  <>
                    <CardHeader title={totalSales} titleTypographyProps={{ variant: 'display' }} />
                    <CardContent sx={{ pt: 0 }}>
                      <Typography variant="caption">
                        Total Sales Amount (USD)
                      </Typography>
                    </CardContent>
                  </>
                )}
              </Card>
              <Card sx={{ flex: 1 }}>
                {isLoading ? (
                  <Skeleton variant="rounded" height={116} />
                ) : (
                  <>
                    <CardHeader title={totalCommission} titleTypographyProps={{ variant: 'display' }} />
                    <CardContent sx={{ pt: 0 }}>
                      <Typography variant="caption">
                        Total Zicasso Commission (USD)
                      </Typography>
                    </CardContent>
                  </>
                )}
              </Card>
            </Stack>

            {isLoading ? (
              <Stack>
                <ZSpinner />
              </Stack>
            ) : (
              <InvoiceTable
                sales={sales || []}
                totalCommission={totalCommission}
                totalSales={totalSales}
              />
            )}

          </>
        )}
      </Stack>
    </Box>
  </Container>
);

export default InvoiceView;
